import React, { useCallback, useState } from 'react'
import { Button } from '@mui/material'

interface TwoStepButtonProps {
  action: () => void
  firstText: string
  secondText: string
}

const TwoStepButton: React.FC<TwoStepButtonProps> = ({ action, firstText, secondText }) => {
  const [isFirstClick, setIsFirstClick] = useState<boolean>(false)

  const handleClick = useCallback<React.MouseEventHandler<HTMLElement>>(() => {
    if (!isFirstClick) {
      setIsFirstClick(true)
      return
    }

    action()
    setIsFirstClick(false)
  }, [isFirstClick, action])

  return (
    <Button variant='outlined' onClick={handleClick}>
      {!isFirstClick ? firstText : secondText}
    </Button>
  )
}

export default React.memo(TwoStepButton)
